import { jsx } from "react/jsx-runtime";
import { Skeleton } from "@nxt-costco-com/forge-components";
const RichTextEntrySkeleton = () => /* @__PURE__ */ jsx(Skeleton, { sx: { height: "128px", width: "100%" }, variant: "rectangular" });
export {
  RichTextEntrySkeleton
};
